import { dialogClasses, svgIconClasses } from '@mui/material'

const styles = {
	actions: {
		gap: "16px",
		padding: "12px 24px 24px",
	},
	button: {
		fontSize: "18px",
		lineHeight: 1.5,
		minWidth: "160px",
		padding: "6.5px 24px",
		textTransform: "none",
	},
	close: {
		[`& .${svgIconClasses.root}`]: {
			color: "var(--black)",
		},
		position: "absolute",
		right: 8,
		top: 8,
	},
	content: {
		padding: "6px 24px 12px",
	},
	dialog: (step: number, isExportCompleted?: boolean) => ({
		[`& .${dialogClasses.paper}`]: {
			maxWidth: step === 0 && !isExportCompleted ? "1097px" : "745px",
		},
	}),
	header: {
		alignItems: "center",
		display: "flex",
		padding: "16px 24px 6px",
	},
	info: {
		"&:before": {
			content: '"•"',
			display: "inline-block",
			margin: "0 8px",
		},
		color: "var(--dark_grey)",
		fontSize: "14px",
	},
	title: {
		color: "var(--black)",
		fontSize: "18px",
		fontWeight: 600,
	},
};

export default styles;